import React from 'react';
const tomos = [{
  color: '🟢',
  title: 'MODULE 01',
  subtitle: 'Annual Planning & Season Structure',
  desc: 'Full season framework with weekly planning templates, periodisation model and monthly objectives.',
  features: 'Pre-season · In-season · Off-season · Weekly planner sheets'
}, {
  color: '🟡',
  title: 'MODULE 02',
  subtitle: '50 Complete Training Sessions',
  desc: 'Ready-to-use sessions for U8 through U18.',
  features: 'U8 · U10 · U12 · U14 · U16 · U18'
}, {
  color: '🔵',
  title: 'MODULE 03',
  subtitle: 'Batting Progression System',
  desc: 'Structured batting development from fundamentals to advanced technique.',
  features: 'Technique · Footwork · Shot Progressions · Drills'
}, {
  color: '🔴',
  title: 'MODULE 04',
  subtitle: 'Bowling Progression System',
  desc: 'Pace & spin bowling frameworks with action checkpoints.',
  features: 'Seam · Swing · Off-spin · Leg-spin · Yorkers'
}, {
  color: '🟣',
  title: 'MODULE 05',
  subtitle: 'Fielding & Wicketkeeping',
  desc: 'Ground fielding, catching, throwing mechanics and specialist wicketkeeping drills.',
  features: 'Ground Fielding · Catching · Throwing · WK Systems'
}, {
  color: '🟠',
  title: 'MODULE 06',
  subtitle: 'Player Assessment & Coaching Tools',
  desc: 'Assessment forms, tracking templates, coaching logs, tactical frameworks.',
  features: 'Assessment · Tactics · Match Prep · 24-Week Log'
}];
const features = ['Annual Planning Templates', 'Complete Ready-to-Use Sessions', 'Skill Progressions by Age', 'Coaching Cue Libraries', 'Player Tracking Forms', 'Warm-Up & Drill Banks', 'Match Preparation Protocols', 'Mental Skills Framework'];
export function WhatYouGet() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-263">
      <div className="max-w-5xl mx-auto" data-id="element-264">
        <h2 className="text-3xl sm:text-5xl font-black text-[#0A0A0A] text-center mb-12 tracking-tight" data-id="element-265">
          Inside the Main Volume — 6 Complete Coaching Modules
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-266">
          {tomos.map(tomo => <div key={tomo.title} className="bg-white border border-[#E5E5EA] rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow flex flex-col" data-id="element-267">
              <div className="flex items-center gap-3 mb-4" data-id="element-268">
                <span className="text-2xl" data-id="element-269">{tomo.color}</span>
                <div data-id="element-270">
                  <h3 className="font-black text-[#0A0A0A] text-sm tracking-wider uppercase" data-id="element-271">
                    {tomo.title}
                  </h3>
                  <p className="text-[#0A0A0A] font-bold text-lg leading-tight" data-id="element-272">
                    {tomo.subtitle}
                  </p>
                </div>
              </div>
              <p className="text-[#0A0A0A] font-bold text-sm mb-2" data-id="element-273">
                {tomo.desc}
              </p>
              <p className="text-[#5A5A66] text-sm font-medium leading-relaxed mt-auto" data-id="element-274">
                {tomo.features}
              </p>
            </div>)}
        </div>

        <div className="bg-[#FAFAFA] border border-[#E5E5EA] rounded-2xl p-6 sm:p-8" data-id="element-275">
          <h4 className="text-center font-black text-[#0A0A0A] mb-6 uppercase tracking-wider text-sm" data-id="element-276">
            What every module includes
          </h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-3 max-w-4xl mx-auto" data-id="element-277">
            {features.map(f => <span key={f} className="text-[#0A0A0A] text-sm font-bold flex items-center gap-2" data-id="element-278">
                <span className="text-[#d4af37] text-lg flex-shrink-0" data-id="element-279">✅</span>
                <span data-id="element-280">{f}</span>
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}